/** Editor i18n catalog: onboarding (spec #304) - the setup checklist behind the small dropdown beside the editor's name. English is the key source; German uses "du" and real umlauts. */
import { defineMessages } from "../core.ts";

export const onboarding = defineMessages(
  {
    title: "Finish setting up",
    progress: "{done} / {total} done",
    error_save: "Could not save that - try again.",
    error_telegram: "Could not start the Telegram link - try again in a moment.",

    step_calendar: "Add the training calendar",
    step_telegram: "Connect Telegram",
    step_availability: "Confirm your availability",
    step_adlingo: "Complete an AdLingo lesson",
    step_billing: "Add your billing details",

    hint_calendar: "Subscribe to the training calendar in your own calendar app - this ticks itself once you open it.",
    hint_telegram: "Link @aditordealerbot so new cards and reminders can reach you.",
    hint_availability: "Set your weekly hours so dispatch knows when to offer you cards.",
    hint_adlingo: "Finish your first lesson in AdLingo.",
    hint_billing: "Add your legal name, address and bank details so payroll can pay you.",

    telegram_connect: "Connect Telegram",
    telegram_opening: "Opening…",
    availability_cta: "Set your availability →",
    adlingo_cta: "Open AdLingo →",
    billing_cta: "Add billing details →",
    calendar_cta: "Add the training calendar →",
    guide_link: "Read the editor handbook",
    toggle: "Setup {done}/{total}",
  },
  {
    title: "Schließ die Einrichtung ab",
    progress: "{done} / {total} erledigt",
    error_save: "Konnte nicht speichern - versuch es noch mal.",
    error_telegram: "Der Telegram-Link konnte nicht gestartet werden - versuch es gleich noch mal.",

    step_calendar: "Füge den Trainingskalender hinzu",
    step_telegram: "Verbinde Telegram",
    step_availability: "Bestätige deine Verfügbarkeit",
    step_adlingo: "Schließ eine AdLingo-Lektion ab",
    step_billing: "Trag deine Rechnungsdaten ein",

    hint_calendar: "Abonnier den Trainingskalender in deiner eigenen Kalender-App - das hakt sich ab, sobald du ihn öffnest.",
    hint_telegram: "Verknüpfe @aditordealerbot, damit dich neue Cards und Erinnerungen erreichen.",
    hint_availability: "Leg deine Wochenstunden fest, damit der Dispatch weiß, wann er dir Cards anbieten kann.",
    hint_adlingo: "Schließ deine erste Lektion in AdLingo ab.",
    hint_billing: "Trag deinen bürgerlichen Namen, deine Adresse und deine Bankverbindung ein, damit die Abrechnung dich bezahlen kann.",

    telegram_connect: "Telegram verbinden",
    telegram_opening: "Wird geöffnet…",
    availability_cta: "Verfügbarkeit einstellen →",
    adlingo_cta: "AdLingo öffnen →",
    billing_cta: "Rechnungsdaten eintragen →",
    calendar_cta: "Trainingskalender hinzufügen →",
    guide_link: "Editor-Handbuch lesen",
    toggle: "Einrichtung {done}/{total}",
  },
);
